<div class="container beneficiary-details-container">
  <div class="modal card-background-copy" id="modal-dialog" tabindex="-1">
    <form [formGroup]="beneficiaryDetailForm" autocomplete="off" role="form" class=" ">
      <div class="row">
        <app-content-top-nav [visibleBackNav]='true' [enableBackNav]='true' (onBackClickHandler)="OnBackClick()">
        </app-content-top-nav>
      </div>
      <div class="row">
        <div class="col-md-12 clear-all title-inner-container">
          <h1 class="custom-header-h2 responsive-text-8" id="beneficiary-header">{{contentData.header}} </h1>
        </div>
      </div>
      <div class="content-container">
        <div class="row"  *ngIf="showGuranteedText" >
          <p class="content-top paragraph" id="beneficiary-gurateedIncome-1">
            {{contentData.guranteedIncomeText1}}
          </p>
          <p class="content-top paragraph paragraph-top" id="beneficiary-gurateedIncome-2">
            {{contentData.guranteedIncomeText2}}
          </p>
        </div>
        <div class="row paragraph-top">
          <div class="col-md-12 clear-all " *ngIf="showVpText">
            <p class="content-top paragraph" id="beneficiary-valueProtection-1">
              {{contentData.VPText1}}
            </p>
            <p class="content-top paragraph paragraph-top" id="beneficiary-valueProtection-2">
              {{contentData.VPText2}}
            </p>
          </div>
        </div>
        <div class="add-beneficiary-details-container">
          <div class="row add-ben-button-container">
            <button class="btn btn-primary margin-0" type="button" (click)="addBeneficiary()"
              *ngIf="beneficiaryDetailForm.get('beneficiary').value.length == 0">
              {{contentData.addBeneficiary}}</button>
          </div>

          <div class="col-md-12">
            <form [formGroup]="beneficiaryDetailForm">
              <div formArrayName="beneficiary">
                <div class="col-md-12 line" *ngFor="let bene of Beneficiary.controls; let i= index;"
                  [formGroupName]="i">
                  <small *ngIf="i == 0">{{contentData.step}}1</small>

                  <h5 [ngClass]="{'pt-15': i > 0}"> {{contentData.beneficiaryDetails}}</h5>
                  <div class="Beneficiary-header">
                    <h6>{{contentData.beneficiary}} {{i +1}}</h6>

                    <div><span class="remove">{{contentData.remove}}</span> <i class="icon icon-bin delete-icon reflect"
                        alt="" (keyup.enter)="removeBeneficiary(i+1, bene)" tabindex="0"
                        (click)="removeBeneficiary(i+1, bene)" aria-hidden="true"></i></div>
                  </div>


                  <div class="col-md-5 clear-all">
                    <app-dropdown [dropdownConfig]="titleConfig" [pageName]="'beneficiaryDetails'"
                      [controlName]="'userTitle'" [parent]="bene" (onChangeHandler)="detectChange(bene)">
                    </app-dropdown>
                  </div>

                  <div class="col-md-12 clear-all">
                    <div class="col-md-5 clear-all input-wrap">
                      <app-other-title-dropdown [parent]="bene" [controlName]="'otherTitle'"
                        [otherTitleList]="otherTitleList"></app-other-title-dropdown>
                    </div>
                  </div>
                  <!-- <div class="col-md-12 clear-all margin-top-30"> -->
                  <div class="col-md-5 clear-all input-wrap">
                    <app-nametext-input [pageName]="'beneficiaryDetails'" [controllerData]="fnameTextCodeConfig"
                      [parent]="bene" [controlName]="'forename'" formControlName="forename">
                    </app-nametext-input>

                  </div>

                  <div class="col-md-2 mrg-top">
                    <app-tool-tip-notification [childId]="'firstNameToolTipInfoCodeConfig'"
                      [tooltipData]="firstNameToolTipInfoCodeConfig"
                      (onDisplayMobileTooltipEmitter)="displayTooltipMessage()"></app-tool-tip-notification>
                  </div>

                  <div class="col-md-5 clear-all">
                    <app-nametext-input [pageName]="'beneficiaryDetails'" [controllerData]="lnameTextCodeConfig"
                      [parent]="bene" [controlName]="'surname'" formControlName="surname">
                    </app-nametext-input>
                  </div>

                  <!-- </div> -->
                  <div class="col-md-12 clear-all margin-top-30 ">
                    <div class="col-md-12 clear-all">
                      <div class="col-md-7 clear-all">
                        <app-date-input [minAge]="'16'" (onBlurHandler)="checkDataChange($event)"
                          [pageName]="'beneficiaryDetails'" [parent]="bene" [controllerData]="dobCodeConfig"
                          formControlName="dateOfBirth">
                        </app-date-input>
                      </div>


                    </div>
                    <div class="col-md-6 clear-all">

                    </div>
                  </div>
                  <div class="col-md-12 clear-all margin-top-20">

                    <lib-custom-address-search [address]="bene.get('address')" [mainParent]="bene"
                      [personalData]="yourPersonalDetails.address" [index]="i"
                      [contentData]="contentData"></lib-custom-address-search>
                    <!-- <div class="line" *ngIf="beneficiaryDetailForm1.get('beneficiary').value.length > 1"></div> -->
                  </div>

                  <app-modal *ngIf="isDelete" [modalConfig]="removeAlertModalConfig" (closeModal)="closeRemoveModal()"
                    (primaryBtnClick)="deleteBeneficiaryRecord(i)" (secondaryBtnClick)="closeRemoveModal()"
                    [saveDataFlag]="false" [isFocus]="false"></app-modal>

                </div>
                <button class="btn" (click)="addBeneficiary()"
                  *ngIf="beneficiaryDetailForm.get('beneficiary').value.length > 0"
                  [disabled]="beneficiaryDetailForm.get('beneficiary').value.length == 20">{{contentData.addAnotherBeneficiary}}</button>

                <div *ngIf="beneficiaryDetailForm.get('beneficiary').value.length > 0">
                  <app-manage-allocations [beneficiaryData]="beneficiaryDetailForm"
                    [contentData]="contentData"></app-manage-allocations>

                </div>
              </div>
            </form>
            <!-- {{beneficiaryDetailForm.value | json }} -->
          </div>
          <app-modal *ngIf="ageValidatorFlag" [modalConfig]="ageAlertModalConfig" (closeModal)="closeAgeModal()"
            (primaryBtnClick)="alertAgePrimaryBtnClick()" (secondaryBtnClick)="alertAgeSecondaryBtnClick()"
            [saveDataFlag]="false"></app-modal>
        </div>
       
      </div>
      <div class="row bottom-container">
        <div class="float-left">
          <app-save [parentElement]="el" [parentFormToValidate]="beneficiaryDetailForm" [location]="'contentBottom'">
          </app-save>
        </div>
        <div class="float-right">
          <app-content-bottom-nav (onNextHandler)="gotoNext()" [userInputDetail]="afterApplyDetail['buttonConfig']"
            [buttonType]="'normalCTA'"></app-content-bottom-nav>
          <!-- <app-content-bottom-nav [userInputDetail]="userInputDetail" (click)="gotoPensionDetails()" [buttonType]="'normalCTA'"></app-content-bottom-nav> -->
        </div>
      </div>
      <app-modal *ngIf="displayTooltipAlert" [modalConfig]="tooltipModalConfig" (closeModal)="closeTooltipModal()"
        (primaryBtnClick)="alertTooltipPrimaryBtnClick($event)" (secondaryBtnClick)="alertSecondaryBtnClick()"
        [tooltipFlag]="true"></app-modal>
    </form>
  </div>
</div>